<template>
    <main-content with_go_back_bar>
        <kt-panel>
            <kt-panel-body>
                <store-form :submit="createStore"></store-form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import { storeService } from '@/common/api.service'
import storeForm from './components/form'
import mainContent from '@/components/main-content'

export default {
    components: {
        storeForm,
        mainContent,
    },
    methods: {
        createStore(e, query) {
            let form = $(e.target)
            let btn = $('#submit_btn')

            form.validate({
                rules: {
                    logo: {
                        required: true,
                    },
                    en_name: {
                        required: true,
                    },
                    fa_name: {
                        required: true,
                    },
                    callback_url: {
                        url: true,
                    },
                    description: {
                        required: true,
                    },
                    gateway_id: {
                        required: true
                    }
                },
            });


            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)
            storeService.create(query)
            .then(response => {
                this.$router.push('/stores')
                this.showMsg(form, 'success', response.data.message)
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTUtil.scrollTop()
                KTApp.unprogress(btn)
            })
        }
    }
}
</script>